<template>
  <div class="mod-cert__selCertCourse">
    <div style="margin-top: 5px">
      <el-row :gutter="10">
        <el-col :span="18">
          <el-card class="box-card">
            <el-form
              label-width="auto"
              :label-position="labelPosition"
              :model="dataForm"
              @keyup.enter.native="quertCourse()"
              @submit.native.prevent
            >
              <el-row :gutter="0">
                <el-col :span="7">
                  <el-form-item
                    :label="$t('couse.coursecodes')"
                    style="width: 98% !important"
                  >
                    <el-input
                      v-model="dataForm.courseCode"
                      clearable
                      :placeholder="$t('cert.inputCourse')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <!-- 学习对象类型 -->
                  <el-form-item
                    :label="$t('cert.coursekinds')"
                    prop="courseKindArr"
                    style="width: 98% !important"
                  >
                    <el-select
                      v-model="dataFormHold.courseKindArr"
                      multiple
                      collapse-tags
                      clearable
                      :placeholder="$t('course.select')"
                    >
                      <el-option
                        v-for="(item, index) in newcourseKind"
                        :key="index"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <!-- APP课程层级 -->
                  <el-form-item
                    prop="appCourseCatalogFirst"
                    style="width: 98% !important"
                    :label="$t('cert.appcatalog')"
                  >
                    <!-- <el-cascader
                            v-model="dataFormHold.appCourseCatalogFirstArr"
                            :options="options"
                            ref="cascaderValue"
                            clearable
                            :props="optionProps"
                            @change="getAppCatalog">
                    </el-cascader> -->

                    <el-select
                      v-model="dataFormHold.appCourseCatalogFirstArr"
                      collapse-tags
                      clearable
                      @change="appCourseClick"
                      :placeholder="$t('course.select')"
                    >
                      <el-option
                        v-for="(item, index) in options"
                        :key="index"
                        :label="item.classifyName"
                        :value="item.classifyId"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <!-- 
                  <el-form-item :label="$t('cert.appcatalog')"
                                prop="appCourseCatalogFirst"
                                style="width: 98%!important;">
                    <el-select v-model="dataFormHold.appCourseCatalogFirstArr"
                               :placeholder="$t('course.select')"
                               multiple
                               clearable
                               collapse-tags>
                      <el-option v-for="item in appCourseCatalogFirstArrs"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item> -->
                </el-col>
                <el-col :span="3" class="query-button">
                  <el-button
                    style="margin-bottom: 7px; float: right"
                    type="primary"
                    @click="quertCourse()"
                    >{{ $t("query") }}</el-button
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="7">
                  <!-- 课程状态 -->
                  <el-form-item
                    :label="$t('cert.courseStatus')"
                    prop="courseStatus"
                    style="width: 98% !important"
                  >
                    <el-select
                      v-model="dataFormHold.courseStatusArr"
                      multiple
                      clearable
                      collapse-tags
                      :placeholder="$t('course.select')"
                    >
                      <el-option
                        v-for="(item, index) in newcoursestatus"
                        :key="index"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="14">&nbsp;</el-col>
                <el-col :span="3" class="query-button">
                  <el-button
                    class="el-back"
                    style="float: right"
                    type="info"
                    @click="resetQuery"
                    >{{ $t("reset") }}</el-button
                  >
                </el-col>
              </el-row>
            </el-form>
            <el-table
              v-loading="dataListLoading"
              ref="selectCourseinfo"
              :data="dataList"
              v-if="showModFlg == '2'"
              border
              @selection-change="dataListSelectionChangeHandle"
              @sort-change="dataListSortChangeHandle"
              style="width: 100%"
              @select="selectRedio"
              @select-all="selectAllRedio"
            >
              <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="50"
                :selectable="checkboxT"
              ></el-table-column>
              <el-table-column
                prop="courseCode"
                :label="$t('couse.coursecode')"
                header-align="center"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="courseNameCn"
                :label="$t('couse.courseNamecns')"
                header-align="center"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="courseNameEn"
                :label="$t('cert.courseNameEn')"
                header-align="center"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="courseCatalog"
                :label="$t('cert.coursekinds')"
                header-align="center"
                align="center"
                :formatter="courseKindFormatter"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="appCourseCatalogFirst"
                :label="$t('cert.appcatalog')"
                header-align="center"
                align="center"
                :formatter="appCourseCatalogFirstFormatter"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="courseStatus"
                :label="$t('cert.courseStatus')"
                header-align="center"
                align="center"
                :formatter="courseStatusFormatter"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <el-table
              v-loading="dataListLoading"
              ref="selectCourseinfo"
              :data="dataList"
              border
              height="350"
              v-if="showModFlg != '2'"
              @selection-change="dataListSelectionChangeHandle"
              @sort-change="dataListSortChangeHandle"
              style="width: 100%"
              @select="selectRedio"
              @select-all="selectAllRedio"
            >
              <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="50"
                :selectable="checkboxT"
              ></el-table-column>
              <el-table-column
                prop="courseCode"
                :label="$t('couse.coursecode')"
                header-align="center"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="courseNameCn"
                :label="$t('couse.courseNamecns')"
                header-align="center"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="courseNameEn"
                :label="$t('cert.courseNameEn')"
                header-align="center"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="courseCatalog"
                :label="$t('cert.coursekinds')"
                header-align="center"
                align="center"
                :formatter="courseKindFormatter"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="appCourseCatalogFirst"
                :label="$t('cert.appcatalog')"
                header-align="center"
                align="center"
                :formatter="appCourseCatalogFirstFormatter"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="courseStatus"
                :label="$t('cert.courseStatus')"
                header-align="center"
                align="center"
                :formatter="courseStatusFormatter"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle"
            >
            </el-pagination>
          </el-card>
        </el-col>
        <!--已选课程-->
        <el-col :span="6">
          <div style="text-align: right; margin-bottom: 15px">
            <el-button plain @click="onOk('1')" size="mini">{{
              $t("cancel")
            }}</el-button>
            <el-button type="primary" @click="onOk('2')" size="mini">{{
              $t("confirm")
            }}</el-button>
          </div>
          <el-card class="box-card">
            <div style="text-align: center">
              <span class="dataBox">{{ $t("cert.selectedCourse") }}</span>
              <div>
                <el-row :gutter="10">
                  <el-col v-for="tag in courseData" :key="tag.courseCode">
                    <el-tag
                      style="margin-bottom: 10px; width: 95%"
                      :key="tag.courseCode"
                      @close="handleClose(tag)"
                      closable
                    >
                      <div
                        style="
                          width: 90%;
                          float: left;
                          overflow-x: hidden;
                          overflow-y: hidden;
                          word-break: keep-all;
                          white-space: nowrap;
                        "
                      >
                        {{ tag.courseNameCn }}
                      </div>
                      <!-- <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
                        <div>{{tag.courseNameCn | ellipsis}}</div>
                      </el-tooltip> -->
                    </el-tag>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import mixinViewModule from "@/mixins/view-module";
import Vue from "vue";
export default {
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 8) {
        return value.slice(0, 8) + "...";
      }
      return value;
    },
  },
  mixins: [mixinViewModule],
  props: {
    inputvalues: String,
    courseInfoList: {
      type: Array,
      required: false,
    },
    showModFlg: {
      type: String,
      required: false,
      default: "1",
    },
  },
  data() {
    return {
      // 编辑面板标签对齐方式
      labelPosition: "left",
      // 查询面板标签宽度
      queryLabelWidth: "70px",
      inputvaluesz: "",
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: "/learning/certinfo/queryCertCourseBaseList",
        getDataListIsPage: true,
        deleteIsBatch: true,
      },
      // 课程状态
      newcoursestatus: this.enums["courseStatus"],
      // 课程类型
      newcourseKind: this.enums["newcourseKind"],
      optionProps: {
        // children: 'subClassifyList',
        label: "classifyName",
        value: "classifyId",
      },
      // appCourseCatalogFirstArrs: [
      //   { value: '10', label: '销售' },
      //   { value: '20', label: '金融' },
      //   { value: '30', label: '管理' },
      //   { value: '40', label: '零件' },
      //   { value: '50', label: '服务' },
      //   { value: '60', label: '机电' },
      //   { value: '70', label: '钣喷' }
      // ],
      datalist: [],
      dataForm: {
        courseKind: "",
        courseCode: "",
        appCourseCatalogFirst: "",
        courseStatus: "",
      },
      dataFormHold: {
        courseKindArr: "",
        appCourseCatalogFirstArr: "",
        courseStatusArr: "",
      },
      options: [],
      courseData: [],
    };
  },
  created() {
    // this.resetQuery()
    this.mixinViewModuleOptions.getDataListURL =
      "/learning/certinfo/queryCertCourseBaseList";
    this.mixinViewModuleOptions.getDataListIsPage = true;
    console.log(this.newcourseKind);
    this.quertCourse();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm));
      if ("regionIds" in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = "";
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(",");
        }
      }
      this.dataListLoading = true;
      this.$request
        .get(this.mixinViewModuleOptions.getDataListURL, {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage
            ? this.page
            : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage
            ? this.limit
            : null,
          ...newDataForm,
        })
        .then((res, total, code, data) => {
          this.dataListLoading = false;
          let resultList = data.data.records;
          this.dataList = resultList;
          this.total = this.mixinViewModuleOptions.getDataListIsPage
            ? parseInt(data.data.total, 10)
            : 0;
          // 延迟加载
          this.$nextTick(() => {
            this.querSelect();
          });
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    appCourseClick(e) {
      console.log(e);
      this.dataFormHold.appCourseCatalogFirstArr = e;
    },
    initMethods() {
      this.resetQuery();
      this.dataForm = {
        courseKind: "",
        courseCode: "",
        appCourseCatalogFirst: "",
        courseStatus: "",
      };
      this.dataFormHold = {
        courseKindArr: "",
        appCourseCatalogFirstArr: "",
        courseStatusArr: "",
      };
      this.options = [];
      this.courseData = [];
      if (
        this.showModFlg === "2" &&
        this.courseInfoList &&
        this.courseInfoList.length > 0
      ) {
        this.courseData = this.courseInfoList;
      }
      this.getOptions();
      this.quertCourse();
      let coursestatusB = [];
      if (this.newcoursestatus && this.newcoursestatus.length > 0) {
        for (var i = 0; i < this.newcoursestatus.length; i++) {
          if (this.newcoursestatus[i].name !== "未发布") {
            coursestatusB.push(this.newcoursestatus[i]);
          }
        }
        this.newcoursestatus = coursestatusB;
      }
    },
    toggleSelection(rows) {
      var chexcksss = this.$refs.selectCourseinfo.selection; // 得到选中的值
      chexcksss.forEach((row) => {
        this.datalist.push({
          id: row.courseId,
          courseKind: row.courseKind,
          course: row.courseCode + "-" + row.courseNameCn,
        });
      });
      this.$emit("inputss", this.datalist);
      this.datalist = [];
    },
    quertCourse() {
      this.page = 1;
      if (this.dataFormHold.courseKindArr instanceof Array) {
        this.dataForm.courseKind = this.dataFormHold.courseKindArr.join(",");
      }
      // if (this.dataFormHold.appCourseCatalogFirstArr instanceof Array) {
      //   this.dataForm.appCourseCatalogFirst = this.dataFormHold.appCourseCatalogFirstArr.join(',')
      // }
      this.dataForm.appCourseCatalogFirst =
        this.dataFormHold.appCourseCatalogFirstArr;
      if (this.dataFormHold.courseStatusArr instanceof Array) {
        this.dataForm.courseStatus =
          this.dataFormHold.courseStatusArr.join(",");
      }
      // console.log(this.dataForm)
      this.getDataList();
      // this.resetQuery()
    },
    // 重置查询条件
    resetQuery() {
      console.log("----");
      this.dataForm = {
        courseKind: "",
        courseCode: "",
        appCourseCatalogFirst: "",
        courseStatus: "",
      };
      this.dataFormHold = {
        courseKindArr: "",
        appCourseCatalogFirstArr: "",
        courseStatusArr: "",
      };
      let obj = {};
      obj.stopPropagation = () => {
        // obj.stopPropagation
      };
      // this.$refs.cascaderValue.clearValue(obj)
      // this.$refs.cascaderValue.value = []
      // console.log(this.$refs.cascaderValue)
      console.log(this.options);
      this.quertCourse();
      // this.dataFormHold = {
      //   courseKindArr: '',
      //   appCourseCatalogFirstArr: '',
      //   courseStatusArr: ''
      // }
      console.log(this.dataFormHold.appCourseCatalogFirstArr);
    },
    selectRedio: function selectRedio(selection, row) {
      let result = [];
      for (let a = 0; a < selection.length; a++) {
        if (row.courseCode === selection[a].courseCode) {
          result.push(row);
          break;
        }
      }
      if (result.length > 0) {
        if (
          this.isSelectElection &&
          this.$refs.selectCourseinfo.selection.length > 1
        ) {
          this.$refs.selectCourseinfo.clearSelection(); // 清空
          this.courseData = [];
          this.courseData.push(row);
          this.$refs.selectCourseinfo.toggleRowSelection(row); // 选择当前行
        } else {
          if (row) {
            if (
              this.showModFlg === "1" &&
              this.courseData &&
              this.courseInfoList
            ) {
              for (var i = 0; i < this.courseInfoList.length; i++) {
                if (
                  String(this.courseInfoList[i].courseCode) ===
                  String(row.courseCode)
                ) {
                  this.$message.warning(this.$t("cert.courseondb"));
                  this.$refs.selectCourseinfo.toggleRowSelection(row, false); // 清空
                  return false;
                }
              }
            }
            this.courseData.push(row);
          }
        }
      } else {
        if (
          this.isSelectElection &&
          this.$refs.selectCourseinfo.selection.length > 1
        ) {
          this.$refs.selectCourseinfo.clearSelection(); // 清空
          this.courseData = [];
        } else {
          for (let b = 0; b < this.courseData.length; b++) {
            if (row.courseCode === this.courseData[b].courseCode) {
              this.courseData.splice(b, 1);
              break;
            }
          }
        }
      }
    },
    async getOptions() {
      await this.$request
        .get("/learning/courseinfo/getAppCourseCatalogList")
        .then((res, total, code, data) => {
          this.options = data.data;
          console.log(this.options);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAppCatalog(prov) {
      console.log(prov);
      // if (prov) {
      //   let labels = this.$refs['cascaderValue'].currentLabels
      //   if (labels.length > 0) {
      //     this.dataForm.firstLevelClassifyId = prov[0]
      //     this.dataForm.firstLevelClassifyName = labels[0]
      //   }
      // }
    },
    // 控制可选项
    checkboxT(row, index) {
      let _this = this;
      let checkFlg = 1;
      if (
        this.showModFlg === "1" &&
        _this.courseInfoList &&
        _this.courseInfoList.length > 0
      ) {
        _this.courseInfoList.forEach(function (item) {
          if (row.courseCode === item.courseCode) {
            checkFlg = 0;
          }
        });
      }
      return checkFlg;
    },
    // 全选
    selectAllRedio(selection) {
      let _this = this;
      if (selection) {
        let courseDataB = [];
        if (_this.courseData && _this.courseData.length > 0) {
          _this.courseData.forEach(function (item) {
            courseDataB.push(item);
          });
        }
        if (selection.length > 0) {
          for (var i = 0; i < selection.length; i++) {
            let hasFlg = false;
            if (courseDataB && courseDataB.length > 0) {
              for (var l = 0; l < courseDataB.length; l++) {
                if (courseDataB[l].courseCode === selection[i].courseCode) {
                  hasFlg = true;
                }
              }
            }
            if (!hasFlg) {
              _this.courseData.push(selection[i]);
            }
          }
        } else {
          _this.courseData = [];
          if (courseDataB && courseDataB.length > 0) {
            for (var j = 0; j < courseDataB.length; j++) {
              let hasFlg = false;
              for (var k = 0; k < _this.dataList.length; k++) {
                if (
                  courseDataB[j].courseCode === _this.dataList[k].courseCode
                ) {
                  hasFlg = true;
                }
              }
              if (!hasFlg) {
                _this.courseData.push(courseDataB[j]);
              }
            }
          }
        }
      }
    },
    // 删除已选备件
    handleClose(data) {
      for (let a = 0; a < this.dataList.length; a++) {
        if (data.courseCode === this.dataList[a].courseCode) {
          this.$refs.selectCourseinfo.toggleRowSelection(
            this.dataList[a],
            false
          ); // 选择当前行
          break;
        }
      }
      this.courseData.splice(this.courseData.indexOf(data), 1);
    },
    // 确认
    onOk: function (flg) {
      let _this = this;
      if (flg === "1") {
        console.log(_this.courseData);
        _this.courseData = [];
      }
      console.log(_this.courseData);
      let contentTabs = true;
      _this.$emit("inputss", _this.courseData, contentTabs);
      console.log(_this.$emit("inputss"));
      _this.$refs.selectCourseinfo.clearSelection();
    },
    // 打开页面时，回填勾选
    querSelect() {
      if (this.courseData && this.courseData.length > 0) {
        var map = new Map();
        this.courseData.forEach(function (item, index) {
          map.set(String(item.courseCode), item);
        });
        let _this = this;
        _this.dataList.forEach(function (dataitem, dataindex) {
          if (map.has(String(dataitem.courseCode))) {
            _this.$refs.selectCourseinfo.toggleRowSelection(dataitem);
          }
        });
      }
    },
    // 课程状态转换
    courseStatusFormatter(row) {
      return Vue.filter("coverEnum")(row.courseStatus, "courseStatus");
    },
    // 学习对象类型转换
    courseKindFormatter(row) {
      return Vue.filter("coverEnum")(row.courseCatalog, "newcourseKind");
    },
    // APP课程层级转换
    appCourseCatalogFirstFormatter(row) {
      if (this.options !== null && this.options.length > 0) {
        for (var i = 0; i < this.options.length; i++) {
          if (
            this.options[i].classifyId ===
            parseInt(row.appCourseCatalogFirst, 10)
          ) {
            return this.options[i].classifyName;
          }
        }
      }
    },
  },
};
</script>
